import type { Session } from '@setplex/tria-api'
import type { ModuleFallbackFlags } from './index.h'

/**
 * Pick options fields from session
 */
export function pick(
  {
    catchupEnabled,
    epgEnabled,
    tvEnabled,
    tvShowEnabled,
    vodEnabled,
    liveEventEnabled,
  }: Session,
  options: ModuleFallbackFlags
): ModuleFallbackFlags {
  return {
    ...options,
    catchupEnabled,
    epgEnabled,
    tvEnabled,
    tvShowEnabled,
    vodEnabled,
    liveEventEnabled,
  }
}
